import { TypeAsserter } from '@attain-apps/type-guards'

import * as core from '../../core'

import type { Employee } from './employee'

export type Project = core.common.Identified<Project.Id> &
  core.common.Named &
  core.common.Coded &
  core.common.Described.Optionally

export namespace Project {
  export type Id = core.dms.data.Record.Id
  export namespace Id {
    export const isId = core.dms.data.Record.Id.isId
    export const assertIsId: TypeAsserter<Id> = TypeAsserter.Factory.from(isId)
  }

  export type WithSponsor = Project & {
    sponsor: WithSponsor.Sponsor
  }
  export type WithPI = Project & {
    piNames: Employee['name'][]
  }
  export namespace WithSponsor {
    export type Sponsor = core.common.Identified<Project.Id> &
      core.common.Named &
      core.common.Coded &
      core.common.Described.Optionally
  }
}
